export default __webpack_public_path__ + "static/media/email.133e2fae.txt";